import { ILabelPrintScenarioDTO, ILabelPrintScenarioViewDTO } from "../../libs/coreapi-dto/dirs/labelPrintScenario";
import CoreApiService from "../../system/api/coreApiService";
import { DictionaryDataProvider } from "./Common";

export class LabelPrintScenarioDataProvider extends DictionaryDataProvider<ILabelPrintScenarioViewDTO, ILabelPrintScenarioDTO> {
    private _coreApiService: CoreApiService

    constructor(coreApiService: CoreApiService) {
        super();
        this._coreApiService = coreApiService
    }

    getDataRequest(): Promise<IDictionaryRequest<ILabelPrintScenarioViewDTO, ILabelPrintScenarioDTO>> {
        return this._coreApiService.labelPrintScenarioRequest
    }

    getItemsView(idGlobal: string, body: IViewBody, callback: (data, totalCount) => void): void {
        this._coreApiService.labelPrintScenarioRequest.then((r) => {
            r.getItemsView(idGlobal, body, (e) => {
                if (e.respType === 'isCompleted') {
                    callback?.(e.data.entities, e.data.totalCount);
                }
                else
                    throw new Error(e.message.title);
            })
        })
    }
}